var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShieldOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3523_168195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3523_168195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.394531 1.90735e-06H32.3946V32H0.394531V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3523_168195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3926 0.625L3.5 3.49925V12.9684C3.5 21.2044 8.65245 28.5604 16.3926 31.375C24.1328 28.5604 29.2853 21.2044 29.2853 12.9684V3.49925L16.3926 0.625Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1821 4.70354L26.3462 5.85485V12.9686C26.3462 16.4034 25.3047 19.7059 23.3342 22.5192C21.5712 25.0362 19.1864 26.988 16.3919 28.2119C13.5974 26.988 11.2126 25.0362 9.44963 22.5192C7.47913 19.7059 6.4375 16.4034 6.4375 12.9686V5.85485L16.3919 3.6356",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1856 14.7788C21.1856 16.0535 20.6686 17.2075 19.8334 18.0428C18.9981 18.878 17.8441 19.395 16.5694 19.395C14.0199 19.395 11.9531 17.3282 11.9531 14.7788C11.9531 13.504 12.4702 12.35 13.3054 11.5148C13.6655 11.1546 14.0843 10.854 14.5469 10.6283C14.7583 11.5498 15.5835 12.2375 16.5694 12.2375C17.5553 12.2375 18.3805 11.5498 18.5918 10.6283C19.0545 10.854 19.4733 11.1546 19.8334 11.5148C20.6686 12.35 21.1856 13.504 21.1856 14.7788Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6421 10.1629C18.6421 11.3088 17.7131 12.2378 16.5671 12.2378C15.4212 12.2378 14.4922 11.3088 14.4922 10.1629C14.4922 9.01692 15.4212 8.08792 16.5671 8.08792C17.7131 8.08792 18.6421 9.01692 18.6421 10.1629Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7152 12.2378L11.2617 10.4055V8.71886",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7152 17.3082L11.2617 19.1405V20.8271",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9532 14.7788H9.88613L8.72656 13.6193",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4297 12.2378L21.8832 10.4055V8.71886",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4297 17.3082L21.8832 19.1405V20.8271",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 14.7788H23.2546L24.4141 13.6193",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 12.2374V14.1987",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3523_168195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0001,
    height: 32,
    fill: "white",
    transform: "translate(0.386719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_shield_outlined_white.4eb71c56cbb162bf6b3eae16c08cde4a.svg";
export { ForwardRef as ReactComponent };